import { render, staticRenderFns } from "./CarArchive.vue?vue&type=template&id=1d65cef4&scoped=true&"
import script from "./CarArchive.vue?vue&type=script&lang=js&"
export * from "./CarArchive.vue?vue&type=script&lang=js&"
import style0 from "./CarArchive.vue?vue&type=style&index=0&id=1d65cef4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65cef4",
  null
  
)

export default component.exports